import React, { useContext } from "react";
import { Fade } from "react-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.css";
 

// import landingPerson from "../../assets/lottie/landingPerson";
// import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import Tilt from "react-parallax-tilt";

import { greeting  } from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import Type from "./Type";

export default function Greeting() {
  const { isDark } = useContext(StyleContext);
  if (!greeting.displayGreeting) {
    return null;
  }

 

  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                Hi Everyone, <span className="name"> {greeting.title} </span>
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>

              <h2 id="typing-effect" style={{ color: "#ae6d79" }}>
                <Type />
              </h2>

              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {greeting.subTitle}
              </p>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="Contact me" href="#contact" />
                <Button
                  text="See my resume"
                  newTab={true}
                  href={greeting.resumeLink}
                />
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <Tilt scale={1.01} transitionSpeed={1500}>
              <img
               title="coding-time"
               style={{width:"95%",height:"500px"}}
               src="https://i.ibb.co/ck3Sb3Q/animation-500-krvxxfi7.gif"
                alt="greetingImage"
              />
             </Tilt>
            {/* {illustration.animated ? (
              <DisplayLottie animationData={landingPerson} />
            ) : (
              <Tilt scale={1.07} transitionSpeed={2500}>
                <img
                  style={{ width: "100%" }}
                  src={require("../../assets/images/developerActivity.svg")}
                  alt="greetingImage"
                />
              </Tilt>
            )} */}
          </div>
        </div>
      </div>
    </Fade>
  );
}
